import { request } from "react-rb/request"

/**
 * List snippets for the account.
 *
 * @return {object[]} The snippets
 */
export async function listSnippets() {
  const response = await request("/account/snippets/options")

  if (!response.ok) throw response
  return response.data
}
